var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAssignment48Filled = function SvgIconAssignment48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.35 11.3h-1.7v-.1a2.9 2.9 0 0 0-2.9-2.9H19.2a2.9 2.9 0 0 0-2.9 2.9v.1h-1.7a5.3 5.3 0 0 0-5.3 5.3v17.8a5.3 5.3 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3V16.6a5.302 5.302 0 0 0-5.35-5.3Zm-16.9 17.5h15v3.4h-15v-3.4Zm0-3.6v-3.4h15v3.4h-15Zm3.2-13.5h8.6v2.6h-8.6v-2.6Z",
    fill: "current"
  })));
};
export default SvgIconAssignment48Filled;